import settings from '../settings.js'

import eventlistHtml from '../templates/eventlist.html'

function initFitnessEvents(scope, state, ionicModal, ionicPopup, interval, UserService, FitnessService) {
    scope.doShowEventConfirmationRequest = true;

    scope.confirmEvent = (activityId) => {
        scope.eventListModal.hide();
        state.go('app.showevent', { activityId: activityId });
    };

    ionicModal.fromTemplateUrl(eventlistHtml, {
        scope: scope
    }).then((modal) => {
        scope.eventListModal = modal;
    });
    
    scope.closeEventList = () => {
        scope.eventListModal.hide();
        scope.showEventConfirmationRequestPopup();
    };    

    scope.showEventConfirmationRequestPopup = () => {
        if (!scope.doShowEventConfirmationRequest)
            return false;

        scope.confirmableEvents = FitnessService.getConfirmableEvents();

        if (!scope.confirmableEvents.length)
            return false;

        ionicPopup.show({
            title: _locale('event confirmation').ucfirst(), 
            template: `
                    ${scope.confirmableEvents.length > 1 ?
                        (_locale('you have unconfirmed events.').ucfirst() + '<br><br>' + _locale('do you want a list of the events?').ucfirst()) :
                        (_locale('you have an unconfirmed event.').ucfirst() + '<br><br>' + _locale('do you want to go to event?').ucfirst())
                    }`,
            scope: scope,
            cssClass: "popup-vertical-buttons",
            buttons: [{
                text: _locale('yes').ucfirst(),
                onTap: (e) => 1
            }, {
                text: _locale('no').ucfirst(),
                onTap: (e) => 0
            }/*, {
                text: _locale("no, and don't ask again").ucfirst(),
                onTap: (e) => -1
            }*/]
        }).then((showConfirmable) => {
            if (showConfirmable === 1) {
                if (scope.confirmableEvents.length > 1)
                    scope.eventListModal.show();
                else if (scope.confirmableEvents.length === 1)
                    state.go('app.showevent', { activityId: scope.confirmableEvents[0].activityId });
            }
            else if (showConfirmable === -1) {
                scope.doShowEventConfirmationRequest = false;
            }
        })
        .catch((err) => console.log(err));
    };
    
    scope.previousConfirmationPopupMoment = null;

    /*
    //Vahvistus on aluksi pois päältä!
    //Show event confirmation popup if something changes. Don't show on showevent pages
    scope.$watch(() => (FitnessService.getUserCanConfirm() && FitnessService.getConfirmableEvents().length > 0), (newCanConfirm, oldCanConfirm, scope) => {

        if (['app.showevent'].indexOf(state.current.name) !== -1)
            return false;

        if (!scope.doShowEventConfirmationRequest || !newCanConfirm || oldCanConfirm)
            return false;

        scope.previousConfirmationPopupMoment = moment();

        scope.showEventConfirmationRequestPopup();
    });
    /**/

    let fitnessUpdateInProgress = false;
    
    const updateEvents = () => {
        if (settings.fitnessEnabled && !fitnessUpdateInProgress && (!settings.fitnessRequiresLogin || UserService.loginData.loginState === 2)) {
            fitnessUpdateInProgress = true;

            console.log(`[${performance.now()}] Calling FitnessService.getFitnessData() from initFitnessEvents.updateEvents()`);

            FitnessService.getFitnessData().catch((err) => {
                console.log(err);
            }).finally(() => {
                fitnessUpdateInProgress = false;
            });
        }
    };

    //No need to run automatically when using jumppakalenteri

    //updateEvents(); //Run once immediately
    //interval(updateEvents, settings.refreshEventDataMinutes * 60 * 1000);
}

export default initFitnessEvents